import GlobalDispatcher from "../../events/GlobalDispatcher";
import DataProvider from "./BaseDataProvider";

export default class BaseServerManager {
    constructor() {
        this.dataProvider = null;
        this.timeout = null;
        this.init();
        this.addListeners();
    }

    init() {
        this.addDataProvider();
    }

    addDataProvider() {
        this.dataProvider = new DataProvider();
    }

    addListeners() {
        GlobalDispatcher.add('model:init', this.onInit, this);
        GlobalDispatcher.add('dataProvider:hasResponse', this.onResponse, this);
    }

    startTimeout() {
        this.timeout = setTimeout(()=>{
            GlobalDispatcher.dispatch('showMessage', {type:'connectionTimeout'});
        }, 5000);
    }

    stopTimeout() {
        clearTimeout(this.timeout);
    }

    onInit() {
        let request = {
            action: 'init'
        };
        this.dataProvider.action(request);
        this.startTimeout();
    }

    onResponse(data) {
        switch (data.params.action) {
            case 'init':
            case 'reconnect':
                this.hasInitData(data.params);
                break;
        }
        this.stopTimeout();
    }

    hasInitData(data) {

    }
}